import React from 'react';

export interface DecisionBadgeConfig {
  label: string;
  bg: string;
  color: string;
}

export interface DecisionBadgeProps {
  config: DecisionBadgeConfig;
}

/** Small mono badge showing a decision label (e.g. "NF", "OK", "FA"). */
export const DecisionBadge: React.FC<DecisionBadgeProps> = ({ config: c }) => (
  <span
    style={{
      fontSize: 9,
      fontWeight: 700,
      fontFamily: 'var(--font-mono)',
      padding: '2px 5px',
      borderRadius: 3,
      background: c.bg,
      color: c.color,
      letterSpacing: '0.03em',
    }}
  >
    {c.label}
  </span>
);
